<template>
	<div class="nutstore-share not-mobile">
		<a href="javascript:;" @click="toggleCode">
			<img
				class="share-img"
				ref="share"
				src="../../images/svg/float-share.svg"
				alt
			/>
		</a>
		<div class="qr-code" v-if="visiable">
			<p class="qr-title">{{ getConstants('EAGLE_LANDING_FLOAT_SHARE') }}</p>
			<p class="qr-subitle">
				{{ getConstants('EAGLE_LANDING_FLOAT_SHARE_DESCRIPTION') }}
			</p>
			<img class="qr-img" :src="url" alt />
		</div>
	</div>
</template>
<script>
import QRCode from 'qrcode'
import buyStore from '../../buyStore'
export default {
	data() {
		return {
			visiable: false,
			url: '',
		}
	},

	methods: {
		toggleCode() {
			this.visiable = !this.visiable
		},
		hideCode(e) {
			if (e.target !== this.$refs.share) {
				this.visiable = false
			}
		},
	},
	mounted() {
		QRCode.toDataURL(location.href.replace(location.hash, ''), {
			type: 'image/jpeg',
			quality: 1,
		}).then(url => {
			this.url = url
		})

		buyStore.$on('bodyClicked', e => {
			this.hideCode(e)
		})
	},
}
</script>

<style lang="scss" scoped>
.nutstore-share {
	position: relative;
	a {
		display: block;
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
	.share-img {
		box-shadow: 0 0 16px 0 rgba(91, 136, 176, 0.24);
		height: 60px;
		width: 60px;
		border-radius: 50%;
		cursor: pointer;
	}
	.qr-code {
		position: absolute;
		border-radius: 4px;
		left: -256px;
		bottom: 0;
		width: 240px;
		height: 240px;
		text-align: center;
		box-shadow: 0 0 24px 0 rgba(164, 173, 181, 0.24);
		background: #fff;
	}
	.qr-title {
		margin-top: 24px;
		font-size: 14px;
		color: #107ffc;
	}
	.qr-subitle {
		margin: 8px auto 4px;
		font-size: 12px;
		color: #8e8e8e;
		width: 180px;
	}
	.qr-img {
		display: inline-block;
		width: 160px;
		height: 160px;
	}
}
</style>
